import {
    getEofiderTypeline,
    getEofider,
    getEofiderAchr2,
    getEofiderChapv,
    getEofiderSaon,
    getEofiderOchotkl,
    getEofiderAchr1,
    getEofiderSpotkl,
    getEofiderSposobprokl,
    getEofiderMatopor,
    getEofiderTor
} from "@/service/e-grid-service";

export default {
    state() {
        return {
            eofider: [],
            typeline: [],
            achr2: [],
            chapv: [],
            saon: [],
            ochotkl: [],
            achr1: [],
            spotkl: [],
            sposobprokl: [],
            matopor: [],
            tor: []
        }
    },
    mutations: {
        setEosrcEofiderDict(state, {dictName, data}) {
            state[dictName] = data;
        }

    },
    actions: {
        async loadEosrcEofider({commit}, payload) {
            const data = await getEofider(payload);
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'eofider', data: data.data !== null ? data.data : []})
            }
        },
        async loadEosrcEofiderTypeline({commit}) {
            const data = await getEofiderTypeline();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'typeline', data: data.data})
            }
        },
        async loadEosrcEofiderAchr2({commit}) {
                const data = await getEofiderAchr2();
                if (data && data.result) {
                    commit('setEosrcEofiderDict', {dictName: 'achr2', data: data.data})
                }
        },
        async loadEosrcEofiderChapv({commit}) {
            const data = await getEofiderChapv();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'chapv', data: data.data})
            }
        },
        async loadEosrcEofiderSaon({commit}) {
            const data = await getEofiderSaon();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'saon', data: data.data})
            }
        },
        async loadEosrcEofiderOchotkl({commit}) {
            const data = await getEofiderOchotkl();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'ochotkl', data: data.data})
            }
        },
        async loadEosrcEofiderAchr1({commit}) {
            const data = await getEofiderAchr1();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'achr1', data: data.data})
            }
        },
        async loadEosrcEofiderSpotkl({commit}) {
            const data = await getEofiderSpotkl();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'spotkl', data: data.data})
            }
        },
        async loadEosrcEofiderSposobprokl({commit}) {
            const data = await getEofiderSposobprokl();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'sposobprokl', data: data.data})
            }
        },
        async loadEosrcEofiderMatopor({commit}) {
            const data = await getEofiderMatopor();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'matopor', data: data.data})
            }
        },
        async loadEosrcEofiderTor({commit}) {
            const data = await getEofiderTor();
            if (data && data.result) {
                commit('setEosrcEofiderDict', {dictName: 'tor', data: data.data})
            }
        },
    }
}